export enum PdpActionEvents {
	ZOOM_OPEN = 'zoom_open',
	ZOOM_CLOSE = 'zoom_close',
	SHIPPING_RETURN_INFO = 'shipping_return_info',
	AVAILABILITY_STORE = 'availability_store',
	SHARE = 'share',
	PRODUCT_CARE = 'product_care',
	PRODUCT_DESCRIPTION = 'product_description',
}
